module.exports = __webpack_public_path__ + "img/qkyd.1070dbaf.png";